<template>
  <div class="pages service">
    <div class="container">
      <h3><a id="_0"></a>“画世界”用户协议</h3>
      <p>
        <strong
          >更新日期：2023年11月2日<br />
          生效日期：2023年11月2日</strong
        >
      </p>
      <p>
        <strong>1.导言</strong><br />
        欢迎使用石家庄幻刺网络科技有限公司提供的“画世界”软件及相关服务。系指公司通过合法拥有并运营的、标注名称为“画世界”的客户端应用程序，向您提供的产品与服务，包括但不限于绘画创作、文字、图片、浏览及推荐等功能，以及连接人与信息的新型服务。《画世界服务协议》（以下简称“本协议”）是您与公司之间就您注册、登录、使用“画世界”软件及相关服务所订立的协议。<br />
        为了更好地为您提供服务，请您在开始使用“画世界”软件及相关服务之前，务必认真阅读
        并充分理解本协议，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、
        同意开通和使用特殊单项服务的条款、法律适用和争议解决条款等。
        其中，免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。如您未满18周岁，请您在法定监护人陪同下仔细阅读并充分理解本协议，并征得法定监护人的同意后使用“画世界”软件及相关服务。
      </p>
      <p>
        <strong
          >除非您接受本协议的全部内容，否则您将无法正常注册、登录、使用（以下统称“使用”）“画世界”软件及相关服务。一旦您使用“画世界”软件及相关服务，则视为您已充分理解本协议，并同意作为本协议的一方当事人接受本协议以及其他与“画世界”软件及相关服务相关的协议和规则（包括但不限于《隐私政策》）的约束。</strong
        >
      </p>
      <p>
        <strong>2.定义</strong><br />
        “画世界”是石家庄幻刺网络科技有限公司推出的一款绘画创作、作品展示、交流和分享的互联网产品，为您提供一种绘画工具，并形成一个聚合绘画兴趣爱好的社区平台。
      </p>
      <p>
        <strong>3.关于账号</strong><br />
        3.1“画世界”软件及相关服务为您提供了注册通道，您有权选择合法且符合公司要求的字符组合作为自己的账号，并自行设置符合安全要求的密码。用户设置的账号、密码是用户用以登录并以注册用户身份使用“画世界”软件及相关服务的凭证。使用部分功能时，可能需要您按照提示以人脸识别等个人信息进行实名验证。如果您提供的注册资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果。<br />
        3.2您在注册和使用账号时应当遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性，不得在注册资料中出现任何违法违规或侵权信息，您的账号名称、头像和简介等注册信息及其他个人信息中不得出现违法和不良信息，（包括但不限于冒用他人姓名、名称、字号、头像等足以让人引起混淆的方式）开设账号，不得恶意注册“画世界”账号（包括但不限于频繁注册、批量注册账号等行为）。公司有权对您提交的注册信息进行审核。<br />
        3.3您的账号仅限于您本人使用，未经公司书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果公司发现或者有合理理由认为使用者并非账号初始注册人，公司有权在未通知您的情况下，暂停或终止向该注册账号提供服务，并注销该账号。<br />
        3.4您有责任维护个人账号、密码的安全性与保密性，并对您以注册账号名义所从事的活动承担全部法律责任，包括但不限于您在“画世界”软件及相关服务上进行的任何数据修改、信息发布、款项支付等操作行为可能引起的一切法律责任。您应高度重视对账号与密码的保密，在任何情况下不向他人透露账号及密码。若发现他人未经许可使用您的账号或发生其他任何安全漏洞问题时，您应当立即通知公司。您理解并同意，在您未进行投诉或提出帐号申诉等方式明确告知画世界官方帐号被他人使用或信息数据泄漏等情况并提供相关证明材料前，画世界有理由相信该帐号行为是您使用帐号的行为。<br />
        3.5为提高您内容曝光量及发布效率，您同意您在本软件/网站的账号及相应账号所发布的全部内容均授权本公司以您的账号自动同步发布至公司及/或关联公司及/或控制公司运营的系列客户端软件及网站。您在本软件/网站发布、修改、删除内容的操作，均会同步到上述系列客户端软件及网站。
        您通过已注册或者已同步的账号登录公司及/或关联公司及/或控制公司运营的系列客户端软件产品及网站时，应遵守该客户端软件产品及网站自身的《用户协议》及其他协议条款的规定。<br />
        3.6您理解并同意，为了充分使用账号资源，如您在注册后未及时进行初次登录使用或连续超过两个月未登录账号使用等情形，公司有权收回您的账号。
      </p>
      <p>
        <strong>4.用户管理</strong><br />
        4.1您不得在接受服务过程中以任何形式发布下列内容或有任何涉及下列内容的行为：<br />
        4.1.1反对中华人民共和国宪法所确定的基本原则的；<br />
        4.1.2危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br />
        4.1.3损害国家荣誉和利益的；<br />
        4.1.4煽动民族仇恨、民族歧视，破坏民族团结的；<br />
        4.1.5破坏国家宗教政策，宣扬邪教和封建迷信的；<br />
        4.1.6散布谣言，扰乱社会秩序，破坏社会稳定的<br />
        4.1.7散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br />
        4.1.8侮辱或者诽谤他人，侵害他人合法权益的；<br />
        4.1.9含有中华人民共和国法律、行政法规禁止的其他内容的。<br />
        4.2您不得利用画世界平台或服务实施包括但不限于以下行为：<br />
        4.2.1创作、复制、发布、传播法律法规禁止，以及侵犯其他用户或第三方知识产权或其他合法权益的信息和作品；<br />
        4.2.2通过非石家庄幻刺网络科技有限公司开发、授权或认可的第三方兼容软件、系统登录或使用画世界平台或服务，或针对画世界平台和相关服务使用非本公司开发、授权或认证的插件；<br />
        4.2.3删除画世界网站或软件及其他副本上所有关于版权的信息、内容；<br />
        4.2.4未经石家庄幻刺网络科技有限公司同意，对画世界网站或软件进行反向工程、反向汇编、反向编译或以其他非法方式自画世界平台获取源代码等；<br />
        4.2.5对于画世界网站或软件相关信息等，未经石家庄幻刺网络科技有限公司同意，擅自实施包括但不限于下列行为：使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版，建立镜像站点、擅自借助画世界发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；<br />
        4.2.6发布破坏画世界网站或软件的内容，发布指向包含病毒或恶意软件的链接，使用管理员密码或者冒充管理员，重复发布垃圾信息，使用替代账号或外部组织来操控画世界数据；<br />
        4.2.7其他违反法律法规、政策及公序良俗、社会公德或干扰画世界正常运营和侵犯其他用户或第三方合法权益内容的行为。<br />
        4.3您理解并同意，即便您上传了作品，画世界仍有权根据作品的具体情况及政策形势，不将该作品对用户公布或向用户提供。<br />
        4.4您须对自己在使用画世界服务过程中的行为承担法律责任。您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿；以及在画世界首先承担了因您的行为导致的行政处罚或侵权损害赔偿责任后，您应给予画世界等额的赔偿。若您违反以上规定，画世界有权作出独立判断立即暂停或终止对您提供部分或全部服务，包括采取冻结、取消帐号使用权限以及删除用户内容等措施。由于存在上述情况，画世界提醒您自行备份作品和相关信息，因画世界依照本协议约定从系统删除您的作品和其他信息内容的，您同意画世界无需对您或任何第三人可能造成的损失进行赔偿。<br />
        4.5您了解并同意，画世界有权应有关部门的要求，向其提供您提交给画世界服务器的必要信息。如您涉嫌侵犯他人合法权益，则画世界有权在初步判断涉嫌侵权行为存在的情况下，向权利人提供关于您的前述必要信息。<br />
        4.6您了解并承诺，非经画世界同意，您不能利用画世界平台或服务进行销售或其他商业用途。如您有需要将画世界平台或服务用于商业用途，应书面通知画世界并获得公司的明确授权。<br />
        4.7在任何情况下, 画世界均不对用户发布的任何内容负责,
        包括但不限于任何内容发生任何错误或纰漏以及衍生的任何损失或损害。画世界有权（但无义务）自行拒绝或删除画世界上的任何内容。用户使用上述内容,
        应自行承担风险。<br />
        4.8您理解画世界可能会在提供服务的过程中以各种方式投放商业广告等商业信息，您同意画世界有权通过向您的邮箱发送电子邮件、向您的账号发送私信或其他方式向您发送前述信息。<br />
        4.9您理解并同意，您主动删除的已发布作品/画集/商品等信息，画世界视为您已不再希望保留该内容，为了防止资源占用，在合适的时机会永久删除该内容，且无法提供恢复服务。<br />
        4.10您可以使用画世界集市进行商品与服务交易，请悉知以下条款：<br />
        4.10.1如果您是未成年人或限制民事行为能力人，请在监护人同意后进行交易。<br />
        4.10.2您在画世界集市购买商品或服务时，请确认商品名称与价格，集市提供的为虚拟商品，成功购买后，如商品无侵权/欺诈/无法使用等问题，不能退款。<br />
        4.10.3如您利用画世界平台系统、规则漏洞，进行不正当交易获取利益，基于维护画世界集市秩序和安全以及画世界合法权益，画世界有权主动执行关闭交易等操作。<br />
        4.10.4如您从画世界平台个人用户购买商品或服务，请务必判断对方身份，谨防上当受骗，如被诈骗造成经济损失，画世界尽量追查违法用户，但不能保证追回经济损失，因此造成的经济损失，画世界不承担赔偿责任。为了交易安全，请在画世界集市购买商品和服务。
      </p>
      <p>
        <strong>5.所有权及知识产权</strong><br />
        5.1画世界将保护知识产权，作为运营的基本原则之一。<br />
        5.2您理解并同意，在使用画世界软件及相关服务时发布上传的文字、图片、视频、等均由您原创或已获合法授权。您通过画世界上传、发布的任何内容的知识产权归属您或原始著作权人所有。<br />
        5.3画世界鼓励并支持分享作品、互相学习，但任何用户以及其他第三方的知识产权都应得到尊重。您应当确保您拥有必要的授权或权限，以便您在画世界制作、复制、发布、传播作品。为免争议，本条所称“作品”包括任何形式的作品、制品、代码、评论、帖子或用户在画世界发布的其他内容。<br />
        5.4除了用户自行创作、发布的作品外，画世界上所有内容，包括但不限于文字、声音、图片、录像、图表、网站画面的安排等内容均由画世界或其他权利人依法拥有其知识产权，包括但不限于著作权、商标权、专利权等。除本协议另有约定外，未经画世界或其他权利人同意，您不得擅自使用、修改、复制、传播、改变、散布、发行或发表上述内容。如有违反，您同意承担由此给画世界或其他权利人造成的一切损失。
      </p>
      <p>
        <strong>6.隐私制度</strong><br />
        6.1您了解并同意，为便于向用户提供更好的服务，画世界将在用户自愿选择服务或者提供信息的情况下收集用户的个人信息，并将这些信息进行整合。在用户使用服务时，服务器会自动记录一些信息，包括但不限于URL、IP地址、浏览器类型、使用语言、访问日期和时间等。为方便用户登录或使用服务，画世界在有需要时将使用cookies等技术，并将收集到的信息发送到对应的服务器。用户可以选择接受或者拒绝cookies。如用户选择拒绝cookies，则用户有可能无法登录或使用依赖于cookies的服务或者功能。画世界收集的信息将成为常规商业档案的一部分，且有可能因为转让、合并、收购、重组等原因而被转移到画世界的继任公司或者指定的一方。画世界将善意使用收集的信息，且采取各项措施保证信息安全。<br />
        6.2画世界不会公开或透露用户的注册资料及保存在服务中的非公开内容，除非画世界在诚信的基础上认为透露这些信息在以下几种情况是必要的：<br />
        6.2.1事先获得用户的明确授权；<br />
        6.2.2遵守有关法律规定，包括在国家有关机关查询时，提供用户的注册信息、用户在画世界的网页上发布的信息内容及其发布时间、互联网地址或者域名<br />
        6.2.3保持维护画世界的知识产权和其他重要权利；<br />
        6.2.4在紧急情况下竭力维护用户个人和社会大众的隐私安全；<br />
        6.2.5根据本条款相关规定或者画世界认为必要的其他情况下。<br />
        6.3画世界可能会与第三方合作向用户提供相关服务，在此情况下，如该第三方同意承担与画世界同等的保护用户隐私的责任，则画世界可将用户的信息提供给该第三方。具体隐私政策条款可见
        《隐私政策》和 《MobTech-隐私政策》。
      </p>
      <p>
        <strong>7.违约处理</strong><br />
        7.1针对您违反本协议或其他服务条款的行为，公司有权独立判断并视情况采取预先警示、拒绝发布、立即停止传输信息、删除跟帖、短期禁止发言、限制账号部分或者全部功能直至永久关闭账号等措施。公司有权公告处理结果，且有权根据实际情况决定是否恢复相关账号的使用。对涉嫌违反法律法规、涉嫌违法犯罪的行为将保存有关记录，并依法向有关主管部门报告、配合有关主管部门调查。<br />
        7.2因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行处理并承担全部可能由此引起的法律责任。因您的违法或违约行为导致公司及其关联公司、控制公司向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿公司及其关联公司、控制公司因此遭受的全部损失。<br />
        7.3公司尊重并保护法人、公民的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用画世界软件及相关服务时上传的文字、图片、视频、音频、链接等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。否则，公司有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，您应自行处理并承担全部可能由此引起的法律责任；如因您的侵权行为导致公司及其关联公司、控制公司遭受损失的（包括经济、商誉等损失），您还应足额赔偿公司及其关联公司、控制公司遭受的全部损失。
      </p>
      <p>
        <strong>8.服务的中断、中止、终止</strong><br />
        8.1您理解并同意，公司提供的画世界软件及相关服务是按照现有技术和条件所能达到的现状提供的。公司会尽最大努力向您提供服务，确保服务的连贯性和安全性。您理解，公司不能随时预见和防范技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵及其他各种安全问题的侵扰等原因可能导致的服务中断、数据丢失以及其他的损失和风险。<br />
        8.2您理解并同意，公司为了服务整体运营的需要，有权在公告通知后修改、中断、中止或终止画世界软件及相关服务，而无须向您负责或承担任何赔偿责任。
      </p>
      <p><strong>9.免责声明</strong></p>
      <p>
        9.1您理解并同意，画世界软件及相关服务可能会受多种因素的影响或干扰，公司不保证(包括但不限于)：<br />
        9.1.1公司完全适合用户的使用要求；<br />
        9.1.2软件中任何错误都将能得到更正。<br />
        9.2对于涉嫌借款、理财或其他涉财产的网络信息、账户密码、广告或推广等信息的，请您谨慎对待并自行进行判断，基于前述原因您因此遭受的财产、利润、商业信誉、资料损失或其他有形或无形损失，公司不承担任何直接、间接、附带、特别、衍生性或惩罚性的赔偿责任。<br />
        9.3您理解并同意，在使用画世界软件及相关服务过程中，可能遇到不可抗力等因素（不可抗力是指不能预见、不能克服并不能避免的客观事件），包括但不限于政府行为、监管政策、自然灾害、网络原因、黑客攻击、战争或任何其它类似事件。出现不可抗力情况时，公司将努力在第一时间及时修复，但因不可抗力给您造成暂停、中止、终止服务或造成任何损失的，您同意公司不承担任何法律责任。<br />
        9.4公司依据本协议约定获得处理违法违规内容的权利，该权利不构成公司的义务或承诺，公司不能保证及时发现违法行为或进行相应处理。<br />
        9.5您理解并同意，关于画世界软件及相关服务，公司不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。您对画世界软件及相关服务的使用行为必须自行承担相应风险。<br />
        9.6您理解并同意，本协议是在保障遵守国家法律法规、维护公序良俗，保护他人合法权益，公司在能力范围内尽最大的努力按照相关法律法规进行判断，但并不保证公司判断完全与司法机关、行政机关的判断一致，如因此产生的后果您已经理解并同意自行承担。<br />
        <strong
          >9.7画世界对不可抗力导致的损失不承担责任。不可抗力包括：自然灾害、法律法规或政府指令的变更，因网络服务特性而特有的原因，例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、突发性的软硬件设备及电子通信设备故障、互联网覆盖范围限制、计算机病毒、黑客攻击等因素，及其他合法范围内的不能预见、不能避免并不能克服的客观情况。</strong
        >
      </p>
      <p>
        <strong>10.未成年人使用条款</strong><br />
        10.1若用户是未满18周岁的未成年人，应在监护人监护、指导并获得监护人同意情况下认真阅读本协议后，方可使用画世界软件及相关服务。<br />
        10.2公司重视对未成年人个人信息的保护，未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待，并在监护人指导时正确使用画世界软件及相关服务。<br />
        10.3未成年用户及其监护人理解如因未成年人违反法律法规、本协议内容，则未成年人及其监护人应依照法律规定承担因此而可能引起的全部法律责任。<br />
        10.4未成年人用户特别提示：<br />
        10.4.1未成年人使用本软件及相关服务应该在其监护人的监督指导下，在合理范围内正确学习使用网络，避免沉迷虚拟的网络空间，养成良好上网习惯。<br />
        10.4.2未成年人用户必须遵守《全国青少年网络文明公约》：<br />
        （1）要善于网上学习，不浏览不良信息；<br />
        （2）要诚实友好交流，不侮辱欺诈他人；<br />
        （3）要增强自护意识，不随意约会网友；<br />
        （4）要维护网络安全，不破坏网络秩序；<br />
        （5）要有益身心健康，不沉溺虚拟时空。<br />
        10.5为更好的保护未成年人隐私权益，公司提醒用户慎重发布包含未成年人素材的内容，一经发布，即视为用户同意本软件及相关服务展示未成年人的信息、肖像、声音等，且允许公司依据本协议使用、处理该等与未成年人相关的内容。
      </p>
      <p>
        <strong>11其他</strong><br />
        11.1通知：所有发给您的通知都可通过电子邮件、常规的信件或在网站/客户端显著位置公告的方式进行传送。<br />
        11.2本协议适用中华人民共和国的法律（不含冲突法）。当本协议的任何内容与中华人民共和国法律相抵触时，应当以法律规定为准，同时相关内容将按法律规定进行修改或重新解释，而本协议其他部分的法律效力不变。<br />
        11.3凡因本协议引起的或与本协议有关的任何争议，均应提交中国国际经济贸易仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁，并由3名仲裁员进行审理。仲裁裁决是终局的，对双方均有约束力。<br />
        11.4本协议自发布之日起实施，并构成您和画世界之间的共识。<br />
        11.5画世界不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响画世界在将来行使该权利。<br />
        石家庄幻刺网络科技有限公司
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "hsjService",
  components: {},
  created() {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
.service {
  .container {
    font-size: 14px;
    line-height: 1.5;
  }
}
</style>
